import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { ENVIRONMENT } from './app/constants';
import { Environment } from './app/types';

fetch('/environment.json', { method: 'GET' })
  .then((res) => res.json())
  .then((environment: Environment) => {
    if (environment.production) {
      enableProdMode();
    }
    platformBrowserDynamic([
      { provide: ENVIRONMENT, useValue: environment }
    ]).bootstrapModule(AppModule);
  })
  .catch((err) => console.error(err));
